import React, { Component } from 'react';
import {Button, Input, Table, Modal, Radio, message } from "antd";
import styled from 'styled-components';
import RoleAPI from '@/api/role';
import utils from '@/utils/auth';
const { Search } = Input;
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
  }
`;

const ModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 30px;
  .item {
    display: flex;
    padding: 15px 0;
    &:nth-child(2) {
      padding: 0 !important;
    }
    .label {
      position: relative;
      white-space: nowrap;
      &.required::before {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
      &::after {
        content:"";
        width: 100%;
        overflow: hidden;
        height: 0;
      }
    }
  }
`;

const RadioWrapper = styled.div`
  margin-left: 20px;
  .radio-item {
    display: flex;
    padding: 10px 0;
    .radio-item__label {
      min-width: 120px;
      white-space: nowrap;
    }
  }
`;

class RoleManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        roleName: '',
        pageNum: 1,
        pageSize: 10
      },
      roleList: [],
      total: 0,

      isVisible: false,
      itemInfo: {},
      permissionList: [],
      menuNames: [
        '门店映射',
        '美团服务管理',
        '技师服务管理',
        '门店营业设置',
        '美团预约数据',
        '角色权限管理',
        '账户管理',
        '非打通门店库存'
      ],
      menuRoleList: [],
      userRole: [],
    };
  }

  componentDidMount() {
    this.initPage();
    this.queryPermissionList();
  }

  initPage = () => {
    const { searchParams } = this.state;
    RoleAPI.queryRolePermissionListList(searchParams)
        .then(({ items: roleList, paginator }) => {
          const { totalCount: total } = paginator;
          this.setState({ roleList, total });
        });
  }

  queryPermissionList = () => {
    const { menuNames } = this.state;
    RoleAPI.queryPermissionList()
      .then(permissionList => {
          let menuRoleList = [];
          menuNames.forEach(item => {
            permissionList.forEach(o => {
              const { permissionId, permissionsKey, desc } = o;
              const [menuName] = desc.split('-');
              const [key, type] = permissionsKey.split(':');

              if (item === menuName) {
                const obj = {
                  menuName,
                  key,
                  value: -1,
                  options: [
                    {
                      label: type,
                      value: permissionId
                    }
                  ],
                };

                const index = menuRoleList.findIndex(o => o.key === key);
                if (index >= 0) { // 权限已经录入
                  menuRoleList.splice(index, 1, Object.assign({}, menuRoleList[index], {
                    options: [
                      ...menuRoleList[index].options,
                      ...obj.options
                    ]
                  }));
                } else {
                  menuRoleList.push(obj);
                }
              }
            });
          });

          this.setState({ menuRoleList });
        });
  }

  onSearch = () => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: 1 }) }, this.initPage);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.initPage);
  }

  showModal = item => {
    const { menuRoleList } = this.state;
    let userRole = [...menuRoleList];
    const { allPermissionsModuleNames, viewPermissionsModuleNames } = item;
    userRole = userRole.map(o => {
      const { menuName } = o;
      const value = allPermissionsModuleNames.includes(menuName) ? 1 : viewPermissionsModuleNames.includes(menuName) ? 0 : -1;
      return Object.assign({}, o, { value });
    });

    this.setState({
      userRole,
      itemInfo: Object.assign({}, item),
      isVisible: true
    });
  }

  onRoleChange = e => {
    const { name, value } = e.target;
    let { userRole } = this.state;
    userRole.forEach(item => {
      if (item.menuName === name) item.value = value;
    });

    this.setState({ userRole });
  }

  modalConfirm = () => {
    const { itemInfo, userRole } = this.state;
    const { roleId } = itemInfo;
    let permissionIds = [];
    userRole.forEach(o => {
      const { value, options } = o;
      if (value === -1) {

      } else if (value === 0) {
        permissionIds.push(Number(options[value].value));
      } else {
        permissionIds = permissionIds.concat(options.map(o => o.value));
      }
    });
    const params = {
      roleId,
      permissionIds
    };
    RoleAPI.bindRolePermission(params)
      .then(() => {
        message.success('更新成功');
        this.setState({ isVisible: false }, this.initPage);
      })
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const { searchParams, roleList, total, isVisible, userRole, itemInfo } = this.state;
    const columns = [
      {
        title: '角色名称',
        dataIndex: 'roleName',
        key: 'roleName',
        width: 200
      },
      {
        title: '仅查看权限',
        render: ({ viewPermissionsModuleNames }) => viewPermissionsModuleNames.join('、') || '无'
      },
      {
        title: '全部权限',
        render: ({ allPermissionsModuleNames }) => allPermissionsModuleNames.join('、') || '无'
      },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 180
      },
      {
        title: '操作',
        render: item => <Button type="link" disabled={!status} onClick={() => this.showModal(item)}>编辑</Button>
      }
    ];

    return (
        <Container>
          <div className="search-wrapper">
            <div className="search">
              <span className="label">角色名称：</span>
              <Search
                  allowClear
                  enterButton="搜索"
                  value={searchParams.roleName}
                  placeholder="请输入角色名称"
                  className="search-input"
                  onSearch={this.onSearch}
                  onChange={e => {
                    const value = e.target.value.trim();
                    this.setState({searchParams: Object.assign(searchParams, { roleName: value })});
                  }}
              />
            </div>
          </div>

          <div className="content-wrapper">
            <Table
                rowKey="roleId"
                columns={columns}
                dataSource={roleList}
                pagination={{
                  current: searchParams.pageNum,
                  pageSize: searchParams.pageSize,
                  total,
                  showTotal: total => `共${total}条`,
                  hideOnSinglePage: false,
                  onChange: this.onPageChange
                }}
            />
          </div>

          <Modal
              title="更新角色权限"
              open={isVisible}
              maskClosable={false}
              onOk={this.modalConfirm}
              onCancel={() => this.setState({ isVisible: false })}
          >
            <ModalWrapper>
              <div className="item">
                <div className="label">角色名称：</div>
                <div className="value">{itemInfo.roleName}</div>
              </div>
              <div className="item">
                <div className="label required">后台权限：</div>
              </div>
                <RadioWrapper>
                  {
                    userRole.map((item, index) =>
                        <div className="radio-item" key={index}>
                          <div className="radio-item__label">
                            {item.menuName}
                          </div>
                          <div className="radio-item__value">
                            <Radio.Group name={item.menuName} value={item.value} onChange={this.onRoleChange}>
                              <Radio value={-1}>无</Radio>
                              <Radio value={0}>查看权限</Radio>
                              <Radio value={1}>编辑权限</Radio>
                            </Radio.Group>
                          </div>
                        </div>
                    )
                  }
                </RadioWrapper>
            </ModalWrapper>
          </Modal>
        </Container>
    );
  }
}

export default RoleManage;
